// extracted by mini-css-extract-plugin
export default {"servicios":"Servicios_servicios__136bo"};